import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { fmDataContext } from "../../Context/FmData";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import LoadingCircle from "../LoadingCircle/LoadingCircle";
import { fmReleasesContext } from "../../Context/ReleasesContext";
import userCan from "../../helpers/userCan";
import { Swiper, SwiperSlide } from "swiper/react";
import { Keyboard, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import Swal from "sweetalert2/dist/sweetalert2.all.min";
import "@sweetalert2/theme-dark/dark.min.css";
import jwtDecode from "jwt-decode";
import ReleaseCard from "../ReleaseCard/ReleaseCard";
import styles from "./ReleaseDetails.module.scss";
import { authenticationContext } from "../../Context/AuthContext";
import LabelCard from "../LabelCard/LabelCard";
import ArtistCard from "../ArtistCard/ArtistCard";

const ReleaseDetails = () => {
  let [mounted, setMounted] = useState(false);

  let { releaseId } = useParams();
  let [params, setParams] = useSearchParams();

  let { baseUrl, navigate, showData, editItemExistence, getData, globalCrumbs, setGlobalCrumbs } = useContext(fmDataContext);
  let { user } = useContext(authenticationContext);

  let [currentRelease, setCurrentRelease] = useState({});
  let onlyTrashed = params.get("archived");
  let [isCurrentReleaseLoading, setIsCurrentReleaseLoading] = useState(true);

  let [isSoftDeleteLoading, setIsSoftDeleteLoading] = useState(false);
  let [isForceDeleteLoading, setIsForceDeleteLoading] = useState(false);
  let [isRestoreLoading, setIsRestoreLoading] = useState(false);

  let { setReleaseMsg } = useContext(fmReleasesContext);

  let userToken = jwtDecode(localStorage.getItem("userToken")).accessToken;

  let artistsSearchInput = useRef();
  let releasesSearchInput = useRef();

  let [artistsSwiperCount, setArtistsSwiperCount] = useState(6);
  let [releasesSwiperCount, setReleasesSwiperCount] = useState(4);

  const setArtistsSlidesCount = () => {
    if (window.innerWidth > 1400) {
      setArtistsSwiperCount(6);
    } else if (window.innerWidth < 1400 && window.innerWidth >= 1200) {
      setArtistsSwiperCount(5);
    } else if (window.innerWidth < 1200 && window.innerWidth > 991.9) {
      setArtistsSwiperCount(4);
    } else if (window.innerWidth < 992 && window.innerWidth > 767.9) {
      setArtistsSwiperCount(3);
    } else if (window.innerWidth < 768 && window.innerWidth > 575.9) {
      setArtistsSwiperCount(2);
    } else if (window.innerWidth < 576 && window.innerWidth > 0) {
      setArtistsSwiperCount(1);
    }
  };

  const setReleasesSlidesCount = () => {
    if (window.innerWidth >= 1400) {
      setReleasesSwiperCount(4);
    } else if (window.innerWidth < 1400 && window.innerWidth > 1199.9) {
      setReleasesSwiperCount(3);
    } else if (window.innerWidth < 1200 && window.innerWidth > 991.9) {
      setReleasesSwiperCount(3);
    } else if (window.innerWidth < 992 && window.innerWidth > 767.9) {
      setReleasesSwiperCount(2);
    } else if (window.innerWidth < 768 && window.innerWidth > 0) {
      setReleasesSwiperCount(1);
    }
  };

  const softDeleteRelease = (reqMethod, pathName, headers, setLoading) => {
    if (userCan("fm_release_soft_delete")) {
      Swal.fire({
        title: "Are you sure?",
        html: `<p class="mb-0">You will delete <span class="fu-text-light-gray">${currentRelease.data.release_title}</span></p>`,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          cancelButton: "popup-btn",
          confirmButton: "popup-btn",
        },
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          if (currentRelease.data.is_from_top_five) {
            setReleaseMsg("Unable to delete release in top releases list");
            navigate("/fm-releases");
          } else {
            editItemExistence(reqMethod, pathName, headers, setLoading)
              .then((response) => {
                setReleaseMsg(`${currentRelease.data.release_title} Deleted Successfully`);
                navigate("/fm-releases");
              })
              .catch((error) => {
                navigate("/not-found");
              });
          }
        }
      });
    } else {
      navigate("/not-found");
    }
  };

  const restoreRelease = (reqMethod, pathName, headers, setLoading) => {
    if (userCan("fm_release_restore_trashed")) {
      Swal.fire({
        title: "Are you sure?",
        html: `<p class="mb-0">You will restore <span class="fu-text-light-gray">${currentRelease.data.release_title}</span></p>`,
        icon: "question",
        showCancelButton: true,
        customClass: {
          cancelButton: "popup-btn",
          confirmButton: "popup-btn",
        },
        confirmButtonText: "Yes, restore it!",
      }).then((result) => {
        if (result.isConfirmed) {
          editItemExistence(reqMethod, pathName, headers, setLoading)
            .then((response) => {
              setReleaseMsg(`${currentRelease.data.release_title} Restored Successfully`);
              navigate("/fm-releases");
            })
            .catch((error) => {
              navigate("/not-found");
            });
        }
      });
    } else {
      navigate("/not-found");
    }
  };

  const forceDeleteRelease = (reqMethod, pathName, headers, setLoading) => {
    if (userCan("fm_release_force_delete")) {
      Swal.fire({
        title: "Are you sure?",
        html: `<p class="mb-0">You will delete <span class="fu-text-light-gray">${currentRelease.data.release_title}</span> permanently</p><p class="mb-0">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          cancelButton: "popup-btn",
          confirmButton: "popup-btn",
        },
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          if (currentRelease.data.is_from_top_five) {
            setReleaseMsg("Unable to delete release in top releases list");
            navigate("/fm-releases");
          } else {
            editItemExistence(reqMethod, pathName, headers, setLoading)
              .then((response) => {
                setReleaseMsg(`${currentRelease.data.release_title} Deleted Permanently Successfully`);
                navigate("/fm-releases");
              })
              .catch((error) => {
                navigate("/not-found");
              });
          }
        }
      });
    } else {
      navigate("/not-found");
    }
  };

  const getRelease = (reqMethod, pathName, setLoading = setIsCurrentReleaseLoading, headers, params) => {
    showData(reqMethod, pathName, setLoading, headers, params)
      .then((response) => {
        // ------------------ REMOVE BEFORE PRODUCTION --------------------------------
        // if (response.data.data.release_image.includes("via.placeholder.com")) {
        //   response.data.data.release_image = response.data.data.release_image.replace("http://127.0.0.1:8000/storage/", "");
        // }
        // if (response.data.data.release_label && response.data.data.release_label.label_image.includes("via.placeholder.com")) {
        //   response.data.data.release_label.label_image = response.data.data.release_label.label_image.replace("http://127.0.0.1:8000/storage/", "");
        // }
        // if (response.data.data.related_releases !== null) {
        //   response.data.data.related_releases.forEach((release) => {
        //     if (release.release_image.includes("via.placeholder.com")) {
        //       release.release_image = release.release_image.replace("http://127.0.0.1:8000/storage/", "");
        //     }
        //   });
        // }
        // if (response.data.data.release_artists !== null) {
        //   response.data.data.release_artists.forEach((artist) => {
        //     if (artist.artist_image.includes("via.placeholder.com")) {
        //       artist.artist_image = artist.artist_image.replace("http://127.0.0.1:8000/storage/", "");
        //     }
        //   });
        // }
        // ------------------ REMOVE BEFORE PRODUCTION --------------------------------
        setCurrentRelease(response.data);
        setLoading(false);
      })
      .catch((error) => {
        navigate("/not-found");
      });
  };

  useEffect(() => {
    getRelease(
      "GET",
      `${baseUrl}fm-release/${releaseId}`,
      setIsCurrentReleaseLoading,
      {
        Accept: "application/json",
        "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
        Authorization: `Bearer ${userToken}`,
      },
      {
        only_trashed: onlyTrashed,
      }
    );
    setMounted(true);

    setArtistsSlidesCount();
    setReleasesSlidesCount();
    window.addEventListener("resize", function () {
      setArtistsSlidesCount();
      setReleasesSlidesCount();
    });
  }, []);

  useEffect(() => {
    getRelease(
      "GET",
      `${baseUrl}fm-release/${releaseId}`,
      setIsCurrentReleaseLoading,
      {
        Accept: "application/json",
        "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
        Authorization: `Bearer ${userToken}`,
      },
      {
        only_trashed: onlyTrashed,
      }
    );
    setMounted(true);
  }, [releaseId]);

  useEffect(() => {
    if (mounted && currentRelease.data) {
      let globalCrumbsUpdated = globalCrumbs.map((crumb) => {
        if (crumb.name === releaseId.toUpperCase()) {
          crumb.name = currentRelease.data.release_title.toUpperCase();
        }
        return crumb;
      });
      setGlobalCrumbs(globalCrumbsUpdated);
    }
  }, [currentRelease]);

  let [releasesSearchTimeOut, setReleasesSearchTimeOut] = useState("");
  let [releasesSearchText, setReleasesSearchText] = useState("");
  let [isReleasesSearchLoading, setIsReleasesSearchLoading] = useState(false);

  const getSearchReleases = () => {
    setIsReleasesSearchLoading(true);
    if (releasesSearchTimeOut) {
      clearTimeout(releasesSearchTimeOut);
    }
    let getReleasesSearchTimeOut = setTimeout(() => {
      getData(
        "GET",
        `${baseUrl}fm-related-releases`,
        {
          search_query: releasesSearchText,
          release_key: currentRelease.data.release_key,
        },
        setIsReleasesSearchLoading
      )
        .then((response) => {
          // ------------------ REMOVE BEFORE PRODUCTION --------------------------------
          // if (response.data.data !== null && response.data.data.length > 0) {
          //   response.data.data.forEach((release) => {
          //     if (release.release_image.includes("via.placeholder.com")) {
          //       release.release_image = release.release_image.replace("http://127.0.0.1:8000/storage/", "");
          //     }
          //   });
          // }
          // ------------------ REMOVE BEFORE PRODUCTION --------------------------------
          currentRelease.data.related_releases = response.data.data;
          setIsReleasesSearchLoading(false);
        })
        .catch((error) => {
          navigate("/not-found");
        });
    }, 1500);
    setReleasesSearchTimeOut(getReleasesSearchTimeOut);
  };

  useEffect(() => {
    if (mounted) {
      getSearchReleases();
    }
  }, [releasesSearchText]);

  let [artistsSearchTimeOut, setArtistsSearchTimeOut] = useState("");
  let [artistsSearchText, setArtistsSearchText] = useState("");
  let [isArtistsSearchLoading, setIsArtistsSearchLoading] = useState(false);

  const getSearchArtists = () => {
    setIsArtistsSearchLoading(true);
    if (artistsSearchTimeOut) {
      clearTimeout(artistsSearchTimeOut);
    }
    let getArtistsSearchTimeOut = setTimeout(() => {
      getData(
        "GET",
        `${baseUrl}fm-artists`,
        {
          search_query: artistsSearchText,
          release_keys: [currentRelease.data.release_key],
        },
        setIsArtistsSearchLoading
      )
        .then((response) => {
          // ------------------ REMOVE BEFORE PRODUCTION --------------------------------
          // if (response.data.data !== null && response.data.data.length > 0) {
          //   response.data.data.forEach((artist) => {
          //     if (artist.artist_image.includes("via.placeholder.com")) {
          //       artist.artist_image = artist.artist_image.replace("http://127.0.0.1:8000/storage/", "");
          //     }
          //   });
          // }
          // ------------------ REMOVE BEFORE PRODUCTION --------------------------------
          currentRelease.data.release_artists = response.data.data;
          setIsArtistsSearchLoading(false);
        })
        .catch((error) => {
          navigate("/not-found");
        });
    }, 1500);
    setArtistsSearchTimeOut(getArtistsSearchTimeOut);
  };

  useEffect(() => {
    if (mounted) {
      getSearchArtists();
    }
  }, [artistsSearchText]);

  return (
    <>
      {!isCurrentReleaseLoading ? (
        <>
          <div className={styles.release_container}>
            <div className={`pt-4 ${styles.release_info_section}`}>
              <div className="container">
                <div className="row g-3 justify-content-center">
                  {!currentRelease.data.is_pre_order && currentRelease.data.release_spotify_id && (
                    <div className="col-md-10 col-lg-8 col-xl-5">
                      <div>
                        <iframe title="king's outlaw" style={{ borderRadius: "12px" }} src={`https://open.spotify.com/embed/${currentRelease.data.release_spotify_id}?utm_source=generator&theme=0`} width="100%" height="352" allowFullScreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
                      </div>
                    </div>
                  )}
                  <div className={`${!currentRelease.data.is_pre_order && currentRelease.data.release_spotify_id ? "col-12 col-xl-7" : "col-12"}`}>
                    <div className="ps-0 ps-xl-4">
                      <div className={styles.release_info}>
                        <div className="d-flex align-items-center">
                          <div className="d-flex align-items-center">
                            {currentRelease.data.is_from_top_five && (
                              <div className="position-relative z-index-high">
                                <div className="top-five-circle me-2" data-title="from top five releases">
                                  <i className="bi bi-star-fill d-inline-flex"></i>
                                </div>
                              </div>
                            )}
                            {currentRelease.data.is_pre_order && (
                              <div className="position-relative z-index-high">
                                <div className="pre-order-circle me-2" data-title="out soon">
                                  <i className="bi bi-hourglass-split d-inline-flex"></i>
                                </div>
                              </div>
                            )}
                          </div>
                          <h2 className={`mb-0 ${styles.release_title}`}>{currentRelease.data.release_title}</h2>
                        </div>
                        {currentRelease.data.release_artists ? <span className={`mb-4 ${styles.release_artist}`}>{currentRelease.data.release_artists.map((artist, index) => `${artist.artist_name}${index === currentRelease.data.release_artists.length - 1 ? "" : ", "}`)}</span> : ""}
                        <p className={`mb-4 ${styles.release_caption}`} dangerouslySetInnerHTML={{ __html: currentRelease.data.release_description }} />
                        <span className={`${styles.release_date}`}>
                          Release Date:<span className={styles.date}>{currentRelease.data.release_date}</span>
                        </span>
                        <span className={`mb-4 ${styles.release_catalog}`}>
                          Catalog:<span className={styles.catalog}>{currentRelease.data.release_catalog}</span>
                        </span>
                      </div>

                      <div className={styles.stream_icons_container}>
                        {/* beatport */}
                        {currentRelease.data.release_streaming_platform_links.beatport_url ? (
                          <div>
                            <a href={currentRelease.data.release_streaming_platform_links.beatport_url} target="_blank" rel="noreferrer" className={styles.stream_icon}>
                              <svg className={styles.svg_icon} width={18} viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                  <path d="M14.668 24c-3.857 0-6.935-3.039-6.935-6.974a6.98 6.98 0 0 1 1.812-4.714l-4.714 4.714-2.474-2.474 5.319-5.26c.72-.72 1.09-1.656 1.09-2.688V0h3.487v6.604c0 2.026-.72 3.74-2.123 5.143l-.156.156a6.945 6.945 0 0 1 4.694-1.812c3.955 0 6.975 3.136 6.975 6.935A6.943 6.943 0 0 1 14.668 24zm0-10.714c-2.123 0-3.779 1.753-3.779 3.74 0 2.045 1.675 3.78 3.78 3.78a3.804 3.804 0 0 0 3.818-3.78c0-2.065-1.715-3.74-3.819-3.74z"></path>
                                </g>
                              </svg>
                            </a>
                          </div>
                        ) : (
                          ""
                        )}
                        {currentRelease.data.release_streaming_platform_links.spotify_url ? (
                          <div>
                            <a href={currentRelease.data.release_streaming_platform_links.spotify_url} target="_blank" rel="noreferrer" className={styles.stream_icon}>
                              <svg className={styles.svg_icon} width={18} viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                  <path d="M24.849 14.35c-3.206-1.616-6.988-2.563-10.991-2.563-2.278 0-4.484 0.306-6.58 0.881l0.174-0.041c-0.123 0.040-0.265 0.063-0.412 0.063-0.76 0-1.377-0.616-1.377-1.377 0-0.613 0.401-1.132 0.954-1.311l0.010-0.003c5.323-1.575 14.096-1.275 19.646 2.026 0.426 0.258 0.706 0.719 0.706 1.245 0 0.259-0.068 0.502-0.186 0.712l0.004-0.007c-0.29 0.345-0.721 0.563-1.204 0.563-0.273 0-0.529-0.070-0.752-0.192l0.008 0.004zM24.699 18.549c-0.201 0.332-0.561 0.55-0.971 0.55-0.225 0-0.434-0.065-0.61-0.178l0.005 0.003c-2.739-1.567-6.021-2.49-9.518-2.49-1.925 0-3.784 0.28-5.539 0.801l0.137-0.035c-0.101 0.032-0.217 0.051-0.337 0.051-0.629 0-1.139-0.51-1.139-1.139 0-0.509 0.333-0.939 0.793-1.086l0.008-0.002c1.804-0.535 3.878-0.843 6.023-0.843 3.989 0 7.73 1.064 10.953 2.925l-0.106-0.056c0.297 0.191 0.491 0.52 0.491 0.894 0 0.227-0.071 0.437-0.192 0.609l0.002-0.003zM22.899 22.673c-0.157 0.272-0.446 0.452-0.777 0.452-0.186 0-0.359-0.057-0.502-0.154l0.003 0.002c-2.393-1.346-5.254-2.139-8.299-2.139-1.746 0-3.432 0.261-5.020 0.745l0.122-0.032c-0.067 0.017-0.145 0.028-0.224 0.028-0.512 0-0.927-0.415-0.927-0.927 0-0.432 0.296-0.795 0.696-0.898l0.006-0.001c1.581-0.47 3.397-0.74 5.276-0.74 3.402 0 6.596 0.886 9.366 2.44l-0.097-0.050c0.302 0.15 0.506 0.456 0.506 0.809 0 0.172-0.048 0.333-0.132 0.469l0.002-0.004zM16 1.004c0 0 0 0-0 0-8.282 0-14.996 6.714-14.996 14.996s6.714 14.996 14.996 14.996c8.282 0 14.996-6.714 14.996-14.996v0c-0.025-8.272-6.724-14.971-14.993-14.996h-0.002z"></path>
                                </g>
                              </svg>
                            </a>
                          </div>
                        ) : (
                          ""
                        )}
                        {/* soundcloud */}
                        {currentRelease.data.release_streaming_platform_links.sound_cloud_url ? (
                          <div>
                            <a href={currentRelease.data.release_streaming_platform_links.sound_cloud_url} target="_blank" rel="noreferrer" className={styles.stream_icon}>
                              <svg className={styles.svg_icon} width={18} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" viewBox="0 0 97.774 97.774" space="preserve">
                                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                  <g>
                                    <g>
                                      <g>
                                        <path d="M4.723,49.69c-0.209,0-0.38,0.166-0.407,0.395l-0.961,8.781l0.961,8.586c0.027,0.229,0.198,0.396,0.407,0.396 c0.206,0,0.373-0.164,0.406-0.395l1.094-8.588l-1.094-8.781C5.096,49.851,4.929,49.69,4.723,49.69z"></path> <path d="M1.108,53.054c-0.203,0-0.365,0.156-0.392,0.383L0,58.866l0.716,5.337c0.026,0.226,0.188,0.382,0.392,0.382 c0.198,0,0.359-0.156,0.391-0.38l0.847-5.339l-0.847-5.434C1.467,53.21,1.306,53.054,1.108,53.054z"></path>
                                        <path d="M8.564,47.968c-0.258,0-0.464,0.202-0.49,0.48L7.161,58.866l0.913,10.037c0.026,0.279,0.232,0.48,0.49,0.48 c0.253,0,0.459-0.201,0.489-0.479l1.036-10.039L9.053,48.447C9.023,48.17,8.817,47.968,8.564,47.968z"></path> <path d="M12.437,47.6c-0.304,0-0.551,0.242-0.575,0.564L11,58.869l0.862,10.354c0.024,0.32,0.271,0.563,0.575,0.563 c0.299,0,0.545-0.243,0.573-0.563l0.979-10.354L13.01,48.162C12.982,47.842,12.736,47.6,12.437,47.6z"></path>
                                        <polygon points="16.996,69.31 16.996,69.31 16.996,69.312 "></polygon> <path d="M16.996,48.935c-0.024-0.365-0.308-0.644-0.656-0.644c-0.353,0-0.635,0.278-0.657,0.647l-0.814,9.93l0.814,10.441 c0.022,0.367,0.305,0.646,0.657,0.646c0.349,0,0.632-0.279,0.656-0.646l0.923-10.441L16.996,48.935z"></path>
                                        <path d="M20.276,41.985c-0.396,0-0.72,0.322-0.74,0.733l-0.764,16.155l0.764,10.44c0.021,0.406,0.345,0.729,0.74,0.729 c0.392,0,0.716-0.322,0.74-0.732v0.004l0.864-10.44l-0.864-16.156C20.991,42.307,20.667,41.985,20.276,41.985z"></path>
                                        <path d="M24.181,38.264c-0.443,0-0.804,0.358-0.824,0.815c0,0.002-0.715,19.85-0.715,19.85l0.716,10.375 c0.02,0.455,0.38,0.813,0.823,0.813c0.44,0,0.804-0.358,0.823-0.815v0.006l0.809-10.379l-0.809-19.85 C24.985,38.622,24.621,38.264,24.181,38.264z"></path>
                                        <path d="M28.241,36.47c-0.491,0-0.89,0.396-0.907,0.9c0,0.001-0.665,21.508-0.665,21.508l0.665,10.268 c0.018,0.5,0.416,0.895,0.907,0.895c0.488,0,0.887-0.395,0.907-0.898v0.006l0.751-10.27L29.148,37.37 C29.127,36.866,28.729,36.47,28.241,36.47z"></path>
                                        <path d="M33.26,36.647c-0.017-0.552-0.452-0.985-0.989-0.985c-0.541,0-0.976,0.434-0.991,0.985l-0.616,22.231l0.617,10.204 c0.015,0.546,0.449,0.978,0.99,0.978c0.537,0,0.973-0.432,0.989-0.981l0.694-10.198L33.26,36.647z"></path> <polygon points="33.26,69.078 33.26,69.078 33.26,69.083 "></polygon>
                                        <path d="M36.332,36.149c-0.59,0-1.061,0.469-1.075,1.068l-0.566,21.665l0.568,10.105c0.013,0.593,0.483,1.064,1.073,1.064 c0.586,0,1.057-0.472,1.073-1.07v0.008l0.638-10.109l-0.638-21.666C37.389,36.616,36.918,36.149,36.332,36.149z"></path>
                                        <path d="M40.425,36.856c-0.636,0-1.146,0.507-1.158,1.153L38.75,58.882l0.517,10.045c0.012,0.64,0.522,1.145,1.158,1.145 c0.635,0,1.144-0.505,1.156-1.152v0.008l0.58-10.043l-0.58-20.875C41.569,37.363,41.06,36.856,40.425,36.856z"></path>
                                        <path d="M45.235,33.02c-0.196-0.133-0.433-0.211-0.686-0.211c-0.246,0-0.475,0.075-0.668,0.201 c-0.339,0.221-0.566,0.602-0.572,1.036l-0.004,0.234l-0.466,24.598c0,0.014,0.47,9.984,0.47,9.984 c0,0.016,0.002,0.027,0.003,0.042c0.014,0.278,0.119,0.534,0.288,0.737c0.229,0.273,0.57,0.449,0.949,0.449 c0.337,0,0.644-0.139,0.868-0.363c0.225-0.223,0.367-0.531,0.373-0.873l0.052-0.986l0.471-8.984l-0.522-24.839 C45.783,33.618,45.563,33.242,45.235,33.02z"></path>
                                        <polygon points="45.79,68.862 45.79,68.859 45.79,68.863 45.79,68.858 45.79,68.854 45.79,68.854 45.79,68.859 "></polygon> <path d="M49.329,30.665c-0.196-0.12-0.428-0.19-0.673-0.19c-0.316,0-0.607,0.114-0.836,0.302 c-0.294,0.243-0.484,0.609-0.49,1.019l-0.003,0.136l-0.54,26.956l0.276,4.982l0.267,4.85c0.011,0.717,0.604,1.311,1.326,1.311 c0.719,0,1.312-0.594,1.322-1.32v0.01v0.002l0.59-9.834l0,0L49.98,31.794C49.973,31.315,49.711,30.896,49.329,30.665z"></path>
                                        <path d="M85.748,46.063c-1.646,0-3.22,0.334-4.65,0.933c-0.959-10.837-10.047-19.339-21.133-19.339 c-2.714,0-5.357,0.534-7.693,1.437c-0.907,0.352-1.147,0.712-1.156,1.414c0,0.001,0,38.168,0,38.168 c0.009,0.735,0.579,1.308,1.298,1.379c0.031,0.004,33.336,0,33.336,0c6.642,0,12.025-5.324,12.025-11.967 C97.774,51.447,92.391,46.063,85.748,46.063z"></path>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                            </a>
                          </div>
                        ) : (
                          ""
                        )}
                        {/* youtube */}
                        {currentRelease.data.release_streaming_platform_links.youtube_url ? (
                          <div>
                            <a href={currentRelease.data.release_streaming_platform_links.youtube_url} target="_blank" rel="noreferrer" className={styles.stream_icon}>
                              <svg className={styles.svg_icon} width={18} sversion="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" viewBox="0 0 260 180" enableBackground="new 0 0 260 180" space="preserve">
                                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                  <path d="M220,2H40C19.01,2,2,19.01,2,40v100c0,20.99,17.01,38,38,38h180c20.99,0,38-17.01,38-38V40C258,19.01,240.99,2,220,2z M102,130V50l68,40L102,130z"></path>
                                </g>
                              </svg>
                            </a>
                          </div>
                        ) : (
                          ""
                        )}
                        {/* youtube music */}
                        {currentRelease.data.release_streaming_platform_links.youtube_music_url ? (
                          <div>
                            <a href={currentRelease.data.release_streaming_platform_links.youtube_music_url} target="_blank" rel="noreferrer" className={styles.stream_icon}>
                              <svg className={styles.svg_icon} width={18} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="youtube-music">
                                <g fillRule="evenodd">
                                  <path d="M12,4.25c-4.28021,0 -7.75,3.46979 -7.75,7.75c0,4.2802 3.46979,7.75 7.75,7.75c4.2802,0 7.75,-3.4698 7.75,-7.75c0,-4.28021 -3.4698,-7.75 -7.75,-7.75Zm-1.6141,4.10688c-0.2317,-0.13902 -0.52029,-0.14266 -0.75542,-0.00953c-0.23514,0.13313 -0.38048,0.38245 -0.38048,0.65265v6c0,0.2702 0.14534,0.5195 0.38048,0.6526c0.23513,0.1332 0.52372,0.1295 0.75542,-0.0095l5,-3c0.2259,-0.1355 0.3641,-0.3797 0.3641,-0.6431c0,-0.2634 -0.1382,-0.5076 -0.3641,-0.6431l-5,-3.00002Z"></path>
                                  <path d="M12,1.25c-5.93706,0 -10.75,4.81294 -10.75,10.75c0,5.9371 4.81294,10.75 10.75,10.75c5.9371,0 10.75,-4.8129 10.75,-10.75c0,-5.93706 -4.8129,-10.75 -10.75,-10.75Zm-9.25,10.75c0,-5.10863 4.14137,-9.25 9.25,-9.25c5.1086,0 9.25,4.14137 9.25,9.25c0,5.1086 -4.1414,9.25 -9.25,9.25c-5.10863,0 -9.25,-4.1414 -9.25,-9.25Z"></path>
                                </g>
                              </svg>
                            </a>
                          </div>
                        ) : (
                          ""
                        )}
                        {/* apple music */}
                        {currentRelease.data.release_streaming_platform_links.apple_music_url ? (
                          <div>
                            <a href={currentRelease.data.release_streaming_platform_links.apple_music_url} target="_blank" rel="noreferrer" className={styles.stream_icon}>
                              <svg className={styles.svg_icon} width={18} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="apple-music">
                                <path d="m24 6.124c0-.029.001-.063.001-.097 0-.743-.088-1.465-.253-2.156l.013.063c-.312-1.291-1.1-2.359-2.163-3.031l-.02-.012c-.536-.35-1.168-.604-1.847-.723l-.03-.004c-.463-.084-1.003-.138-1.553-.15h-.011c-.04 0-.083-.01-.124-.013h-12.025c-.152.01-.3.017-.455.026-.791.016-1.542.161-2.242.415l.049-.015c-1.306.501-2.327 1.495-2.853 2.748l-.012.033c-.17.409-.297.885-.36 1.38l-.003.028c-.051.343-.087.751-.1 1.165v.016c0 .032-.007.062-.01.093v12.224c.01.14.017.283.027.424.02.861.202 1.673.516 2.416l-.016-.043c.609 1.364 1.774 2.387 3.199 2.792l.035.009c.377.111.817.192 1.271.227l.022.001c.555.053 1.11.06 1.667.06h11.028c.554 0 1.099-.037 1.633-.107l-.063.007c.864-.096 1.645-.385 2.321-.823l-.021.013c.825-.539 1.47-1.29 1.867-2.176l.013-.032c.166-.383.295-.829.366-1.293l.004-.031c.084-.539.132-1.161.132-1.794 0-.086-.001-.171-.003-.256v.013q0-5.7 0-11.394zm-6.424 3.99v5.712c.001.025.001.054.001.083 0 .407-.09.794-.252 1.14l.007-.017c-.273.562-.771.979-1.373 1.137l-.015.003c-.316.094-.682.156-1.06.173h-.01c-.029.002-.062.002-.096.002-1.033 0-1.871-.838-1.871-1.871 0-.741.431-1.382 1.056-1.685l.011-.005c.293-.14.635-.252.991-.32l.027-.004c.378-.082.758-.153 1.134-.24.264-.045.468-.252.51-.513v-.003c.013-.057.02-.122.02-.189 0-.002 0-.003 0-.005q0-2.723 0-5.443c-.001-.066-.01-.13-.027-.19l.001.005c-.026-.134-.143-.235-.283-.235-.006 0-.012 0-.018.001h.001c-.178.013-.34.036-.499.07l.024-.004q-1.14.225-2.28.456l-3.7.748c-.016 0-.032.01-.048.013-.222.03-.392.219-.392.447 0 .015.001.03.002.045v-.002.13q0 3.9 0 7.801c.001.028.001.062.001.095 0 .408-.079.797-.224 1.152l.007-.021c-.264.614-.792 1.072-1.436 1.235l-.015.003c-.319.096-.687.158-1.067.172h-.008c-.031.002-.067.003-.104.003-.913 0-1.67-.665-1.815-1.536l-.001-.011c-.02-.102-.031-.218-.031-.338 0-.785.485-1.458 1.172-1.733l.013-.004c.315-.127.687-.234 1.072-.305l.036-.005c.287-.06.575-.116.86-.177.341-.05.6-.341.6-.693 0-.007 0-.015 0-.022v.001-.15q0-4.44 0-8.883c0-.002 0-.004 0-.007 0-.129.015-.254.044-.374l-.002.011c.066-.264.277-.466.542-.517l.004-.001c.255-.066.515-.112.774-.165.733-.15 1.466-.3 2.2-.444l2.27-.46c.67-.134 1.34-.27 2.01-.4.181-.042.407-.079.637-.104l.027-.002c.018-.002.04-.004.061-.004.27 0 .489.217.493.485.008.067.012.144.012.222v.001q0 2.865 0 5.732z"></path>
                              </svg>
                            </a>
                          </div>
                        ) : (
                          ""
                        )}
                        {/* deezer music */}
                        {currentRelease.data.release_streaming_platform_links.deezer_music_url ? (
                          <div>
                            <a href={currentRelease.data.release_streaming_platform_links.deezer_music_url} target="_blank" rel="noreferrer" className={styles.stream_icon}>
                              <svg className={styles.svg_icon} width={18} xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" viewBox="0 0 24 24" id="deezer">
                                <rect width="4.38" height="1.326" x="9.81" y="8.45"></rect>
                                <rect width="4.375" height="1.325" x="19.625" y="17.066"></rect>
                                <polygon points="24 11.896 19.625 11.896 19.625 13.222 19.652 13.222 19.665 13.227 24 13.227"></polygon>
                                <rect width="4.375" height="1.32" x="19.625" y="15.347"></rect>
                                <polygon points="24 13.627 19.625 13.627 19.625 14.957 19.652 14.957 19.665 14.947 24 14.947"></polygon>
                                <polygon points="9.296 13.627 4.91 13.627 4.91 14.957 4.926 14.957 4.936 14.947 9.296 14.947"></polygon>
                                <polygon points="9.291 15.347 4.91 15.347 4.91 16.687 4.912 16.677 4.911 16.667 9.291 16.667"></polygon>
                                <polygon points="19.121 15.347 14.721 15.347 14.721 16.687 14.738 16.677 14.741 16.667 19.121 16.667"></polygon>
                                <polygon points="24 10.177 19.625 10.177 19.625 11.505 19.652 11.503 19.665 11.507 24 11.507"></polygon>
                                <polygon points="4.906 18.391 4.907 18.391 4.91 18.391 9.28 18.391 9.28 17.066 4.906 17.066"></polygon>
                                <polygon points="19.155 10.177 14.725 10.177 14.725 11.497 14.769 11.497 14.775 11.507 19.155 11.507"></polygon>
                                <polygon points="19.155 11.896 14.725 11.896 14.725 13.222 14.769 13.222 14.775 13.227 19.155 13.227"></polygon>
                                <rect width="4.375" height="1.325" y="17.066"></rect>
                                <polygon points="0 14.957 .016 14.957 .03 14.947 4.39 14.947 4.39 13.627 0 13.627"></polygon>
                                <polygon points="0 16.677 .001 16.667 4.381 16.667 4.381 15.347 0 15.347"></polygon>
                                <polygon points="14.201 15.347 9.81 15.347 9.81 16.677 9.811 16.667 14.201 16.667"></polygon>
                                <polygon points="0 13.222 .03 13.222 .045 13.227 4.4 13.227 4.4 11.896 0 11.896"></polygon>
                                <rect width="4.375" height="1.325" x="19.625" y="8.449"></rect>
                                <polygon points="14.22 13.627 9.82 13.627 9.82 14.957 9.836 14.957 9.84 14.947 14.22 14.947"></polygon>
                                <polygon points="9.855 13.227 14.218 13.227 14.218 11.896 9.818 11.896 9.818 13.222 9.851 13.222"></polygon>
                                <rect width="4.38" height="1.327" x="9.81" y="6.724"></rect>
                                <rect width="4.375" height="1.327" x="19.625" y="6.724"></rect>
                                <polygon points="19.121 13.627 14.721 13.627 14.721 14.957 14.738 14.957 14.741 14.947 19.121 14.947"></polygon>
                                <polygon points="0 11.507 .03 11.507 .045 11.507 4.4 11.507 4.4 10.187 0 10.187"></polygon>
                                <rect width="4.38" height="1.325" x="9.81" y="17.066"></rect>
                                <polygon points="14.235 10.187 9.81 10.187 9.81 11.507 9.842 11.507 9.855 11.507 14.235 11.507"></polygon>
                                <rect width="4.375" height="1.326" x="19.625" y="5"></rect>
                                <polygon points="14.715 18.391 14.717 18.391 19.092 18.391 19.092 17.066 14.715 17.066"></polygon>
                              </svg>
                            </a>
                          </div>
                        ) : (
                          ""
                        )}
                        {/* amazon music */}
                        {currentRelease.data.release_streaming_platform_links.amazon_music_url ? (
                          <div>
                            <a href={currentRelease.data.release_streaming_platform_links.amazon_music_url} target="_blank" rel="noreferrer" className={styles.stream_icon}>
                              <svg className={styles.svg_icon} width={18} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="amazon-music">
                                <path d="M1.57853 5.52271c-.20138-.2441-.5343-.33554-.832105-.22855-.297809.10699-.496425.38939-.496425.70583v5.00001c0 .4142.335788.75.75.75.41422 0 .75-.3358.75-.75v-2.91238l.17147.20784c.14248.1727.35465.27272.57853.27272.22388 0 .43606-.10002.57853-.27272l.17147-.20784v2.91238c0 .4142.33579.75.75.75.41422 0 .75-.3358.75-.75v-5.00001c0-.31644-.19861-.59884-.49642-.70583-.29781-.10699-.63073-.01555-.83211.22855l-.92147 1.11693-.92147-1.11693zM7 5.24999c.41422 0 .75.33579.75.75v4c0 .13811.11193.25001.25.25001h1c.13807 0 .25-.1119.25-.25001v-4c0-.41421.33579-.75.75-.75.4142 0 .75.33579.75.75v4c0 .96651-.7835 1.75001-1.75 1.75001h-1c-.9665 0-1.75-.7835-1.75-1.75001v-4c0-.41421.33579-.75.75-.75zM18 5.24999c.4142 0 .75.33579.75.75v5.00001c0 .4142-.3358.75-.75.75-.4142 0-.75-.3358-.75-.75v-5.00001c0-.41421.3358-.75.75-.75zM14.25 5.24999c-1.1046 0-2 .89543-2 2v.25c0 .9665.7835 1.75 1.75 1.75.1381 0 .25.11193.25.25v.25c0 .27611-.2239.50001-.5.50001h-.75c-.4142 0-.75.3358-.75.75 0 .4142.3358.75.75.75h.75c1.1046 0 2-.8954 2-2.00001v-.25c0-.96649-.7835-1.75-1.75-1.75-.1381 0-.25-.11193-.25-.25v-.25c0-.27614.2239-.5.5-.5h.75c.4142 0 .75-.33578.75-.75 0-.41421-.3358-.75-.75-.75h-.75zM16.7679 13.8373c.0898-.4044.4905-.6593.8948-.5694l4.5 1c.3983.0885.6528.4791.5727.8792l-1 5c-.0812.4062-.4763.6696-.8825.5883-.4062-.0812-.6696-.4763-.5883-.8825l.856-4.28-3.7833-.8408c-.4043-.0898-.6593-.4905-.5694-.8948z"></path>
                                <path d="M.456556 15.4831c.285466-.3001.760194-.312 1.06032-.0266 1.6836 1.6013 5.15078 2.7935 9.29392 2.7935 3.294 0 6.1904-.756 8.0876-1.8933.3552-.2129.8159-.0976 1.0289.2577.2129.3552.0976.8159-.2577 1.0289-2.186 1.3104-5.3666 2.1067-8.8588 2.1067-4.34477 0-8.25602-1.2362-10.3277-3.2066-.300137-.2854-.31203-.7602-.026564-1.0603zM22 5.24999c-.9665 0-1.75.78351-1.75 1.75v3c0 .96651.7835 1.75001 1.75 1.75001h1c.4142 0 .75-.3358.75-.75 0-.4142-.3358-.75-.75-.75h-1c-.1381 0-.25-.1119-.25-.25001v-3c0-.13807.1119-.25.25-.25h1c.4142 0 .75-.33578.75-.75 0-.41421-.3358-.75-.75-.75h-1z"></path>
                              </svg>
                            </a>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.bg_blur} style={{ backgroundImage: `url(${currentRelease.data.release_image})` }}></div>
            <div className={styles.gradient}></div>
          </div>
          <div className="position-relative mt-4 z-index-high">
            <div className="container">
              {/* edit restore delete */}
              <div className="d-flex flex-wrap align-items-center justify-content-center mb-4">
                {currentRelease.data.release_deleted_at === null ? (
                  userCan("fm_release_update") ? (
                    <div className="mx-2 my-1 my-sm-0">
                      <Link to={`/fm-releases/update/${currentRelease.data.release_key}`} className={`btn fu-btn-sm fu-btn-gray ${isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? "disabled" : ""}`} disabled={isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? true : false}>
                        <span className="btn-bg"></span>
                        Edit
                      </Link>
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}

                {currentRelease.data.release_deleted_at === null ? (
                  userCan("fm_release_soft_delete") ? (
                    <div className="mx-2 my-1 my-sm-0">
                      <button
                        className={`btn fu-btn-sm fu-btn-gray ${isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? "disabled" : ""}`}
                        onClick={() =>
                          softDeleteRelease(
                            "DELETE",
                            `${baseUrl}fm-releases/delete/${currentRelease.data.release_key}`,
                            {
                              Accept: "application/json",
                              "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
                              Authorization: `Bearer ${user.accessToken}`,
                            },
                            setIsSoftDeleteLoading
                          )
                        }
                        disabled={isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? true : false}>
                        <span className="btn-bg"></span>
                        Delete
                      </button>
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}

                {currentRelease.data.release_deleted_at !== null ? (
                  userCan("fm_release_restore_trashed") ? (
                    <div className="mx-2 my-1 my-sm-0">
                      <button
                        className={`btn fu-btn-sm fu-btn-gray ${isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? "disabled" : ""}`}
                        onClick={() =>
                          restoreRelease(
                            "PATCH",
                            `${baseUrl}fm-releases/restore/${currentRelease.data.release_key}`,
                            {
                              Accept: "application/json",
                              "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
                              Authorization: `Bearer ${user.accessToken}`,
                            },
                            setIsRestoreLoading
                          )
                        }
                        disabled={isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? true : false}>
                        <span className="btn-bg"></span>
                        Restore
                      </button>
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {userCan("fm_release_force_delete") ? (
                  <div className="ms-2 my-1 my-sm-0">
                    <button
                      className={`btn fu-btn-sm fu-btn-gray ${isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? "disabled" : ""}`}
                      onClick={() =>
                        forceDeleteRelease(
                          "DELETE",
                          `${baseUrl}fm-releases/force-delete/${currentRelease.data.release_key}`,
                          {
                            Accept: "application/json",
                            "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
                            Authorization: `Bearer ${user.accessToken}`,
                          },
                          setIsForceDeleteLoading
                        )
                      }
                      disabled={isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? true : false}>
                      <span className="btn-bg"></span>
                      Force Delete
                    </button>
                  </div>
                ) : (
                  ""
                )}

                {isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? (
                  <div className="position-relative ms-4">
                    <LoadingCircle circleCont={35} icon={30} loader={35} dot={35} />
                  </div>
                ) : (
                  ""
                )}
              </div>
              {/* info tags */}
              <div className="release-tags">
                <div className="mb-4 info-tags-container">
                  {currentRelease.data._id ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">#ID: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentRelease.data._id}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {currentRelease.data.release_key ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">#KEY: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentRelease.data.release_key}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {currentRelease.data.release_genre ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">RELEASE GENRE: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentRelease.data.release_genre.genre_title}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {currentRelease.data.release_artists_count !== null ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">RELEASE ARTISTS COUNT: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentRelease.data.release_artists_count}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {currentRelease.data.related_releases_count !== null ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">RELATED RELEASES COUNT: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentRelease.data.related_releases_count}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {currentRelease.data.release_created_at ? (
                    userCan("created_at_show") ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">CREATED AT: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{new Date(currentRelease.data.release_created_at).toLocaleString("en-US", { timeZone: "Africa/Cairo", hour12: true })}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {currentRelease.data.release_updated_at ? (
                    userCan("updated_at_show") ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">UPDATED AT: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{new Date(currentRelease.data.release_updated_at).toLocaleString("en-US", { timeZone: "Africa/Cairo", hour12: true })}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {currentRelease.data.release_deleted_at ? (
                    userCan("deleted_at_show") ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">DELETED AT: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{new Date(currentRelease.data.release_deleted_at).toLocaleString("en-US", { timeZone: "Africa/Cairo", hour12: true })}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {currentRelease.data.release_created_by ? (
                    userCan("created_by_show") ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">CREATED BY, NAME: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{currentRelease.data.release_created_by.name}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {currentRelease.data.release_created_by ? (
                    userCan("created_by_show") ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">CREATED BY, #ID: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{currentRelease.data.release_created_by._id}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {currentRelease.data.release_created_by ? (
                    userCan("created_by_show") ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">CREATED BY, KEY: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{currentRelease.data.release_created_by.key}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {currentRelease.data.release_updated_by ? (
                    userCan("updated_by_show") ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">UPDATED BY, NAME: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{currentRelease.data.release_updated_by.name}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {currentRelease.data.release_updated_by ? (
                    userCan("updated_by_show") ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">UPDATED BY, #ID: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{currentRelease.data.release_updated_by._id}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {currentRelease.data.release_updated_by ? (
                    userCan("updated_by_show") ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">UPDATED BY, KEY: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{currentRelease.data.release_updated_by.key}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {/* release Label */}
              {currentRelease.data.release_label ? (
                <div className="mb-4">
                  <div className="py-2 mb-4 iu-row-heading">
                    <h2 className="mb-0 row-title">LABEL</h2>
                  </div>
                  <div className="row g-3 ">
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xxl-2">
                      <LabelCard label={currentRelease.data.release_label} />
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {/* release artists */}
              {currentRelease.data.release_artists ? (
                <div className="mb-4">
                  <div className="d-flex flex-column flex-lg-row align-items-center mb-4">
                    <div className="flex-grow-1 iu-row-heading mb-2 mb-lg-0">
                      <h2 className="mb-0 row-title">ARTISTS</h2>
                    </div>
                    <div className="d-flex justify-content-between align-items-center row-search-container ms-0 ms-lg-2">
                      <div className="item-search-box-container flex-grow-1">
                        <div className="loading-fixed-dimensions item-search-box-loading">
                          {isArtistsSearchLoading ? (
                            <div className="position-relative">
                              <LoadingCircle circleCont={20} icon={15} loader={20} dot={20} />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="item-search-box">
                          <input
                            type="text"
                            className="form-control shadow-none"
                            id="artist_search_query"
                            placeholder={`${currentRelease.data.release_title} Artists Search...`}
                            onInput={(e) => {
                              setArtistsSearchText(e.target.value);
                              clearTimeout(artistsSearchTimeOut);
                            }}
                            ref={artistsSearchInput}
                          />
                        </div>
                      </div>
                      <div className="ms-2">
                        <button
                          className="fu-btn fu-btn-gray"
                          onClick={() => {
                            setArtistsSearchText("");
                            clearTimeout(artistsSearchTimeOut);
                            artistsSearchInput.current.value = "";
                          }}>
                          <span className="btn-bg"></span>
                          Clear Search
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="item-artists-search-row-height">
                    {artistsSearchText.length > 0 && !isArtistsSearchLoading && currentRelease.data.release_artists.length === 0 ? (
                      <div className="d-flex flex-column justify-content-center align-items-center item-artists-search-msg-height">
                        <div>
                          <h2 className="fu-text-3-rem fu-text-yellow">
                            <i className="bi bi-search"></i>
                          </h2>
                        </div>
                        <div>
                          <h3 className="h5 fu-text-light-gray line-clamp-2">
                            There Are No Artists Related To<span className="d-inline-flex fu-text-yellow mx-2">{currentRelease.data.release_title}</span>With This Text<span className="d-inline-flex fu-text-yellow mx-2">"{artistsSearchText}"</span>
                          </h3>
                        </div>
                      </div>
                    ) : (
                      <div className="row gx-3">
                        <Swiper className="myswiper py-3 px-2 h-100" slidesPerView={artistsSwiperCount} spaceBetween={10} keyboard={true} navigation={true} modules={[Navigation, Keyboard]}>
                          {currentRelease.data.release_artists.map((artist, index) => (
                            <SwiperSlide key={index}>
                              <ArtistCard artist={artist} />
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
              {/* related releases */}
              {currentRelease.data.related_releases !== null ? (
                <div className="mb-4">
                  <div className="d-flex flex-column flex-lg-row align-items-center mb-4">
                    <div className="flex-grow-1 iu-row-heading mb-2 mb-lg-0">
                      <h2 className="mb-0 row-title">RELEASES</h2>
                    </div>
                    <div className="d-flex justify-content-between align-items-center row-search-container ms-0 ms-lg-2">
                      <div className="item-search-box-container flex-grow-1">
                        <div className="loading-fixed-dimensions item-search-box-loading">
                          {isReleasesSearchLoading ? (
                            <div className="position-relative">
                              <LoadingCircle circleCont={20} icon={15} loader={20} dot={20} />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="item-search-box">
                          <input
                            type="text"
                            className="form-control shadow-none"
                            id="releases_search_query"
                            placeholder={`${currentRelease.data.release_title} Related Releases Search...`}
                            onInput={(e) => {
                              setReleasesSearchText(e.target.value);
                              clearTimeout(releasesSearchTimeOut);
                            }}
                            ref={releasesSearchInput}
                          />
                        </div>
                      </div>
                      <div className="ms-2">
                        <button
                          className="fu-btn fu-btn-gray"
                          onClick={() => {
                            setReleasesSearchText("");
                            clearTimeout(releasesSearchTimeOut);
                            releasesSearchInput.current.value = "";
                          }}>
                          <span className="btn-bg"></span>
                          Clear Search
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="item-releases-search-row-height">
                    {releasesSearchText.length > 0 && !isReleasesSearchLoading && currentRelease.data.related_releases.length === 0 ? (
                      <div className="d-flex flex-column justify-content-center align-items-center item-releases-search-msg-height">
                        <div>
                          <h2 className="fu-text-3-rem fu-text-yellow">
                            <i className="bi bi-search"></i>
                          </h2>
                        </div>
                        <div>
                          <h3 className="h5 fu-text-light-gray line-clamp-2">
                            There Are No Releases Related To<span className="d-inline-flex fu-text-yellow mx-2">{currentRelease.data.release_title}</span>With This Text<span className="d-inline-flex fu-text-yellow mx-2">"{releasesSearchText}"</span>
                          </h3>
                        </div>
                      </div>
                    ) : (
                      <div className="row gx-3">
                        <Swiper className="myswiper px-2 h-100" slidesPerView={releasesSwiperCount} spaceBetween={10} keyboard={true} navigation={true} modules={[Navigation, Keyboard]}>
                          {currentRelease.data.related_releases.map((release, index) => (
                            <SwiperSlide key={index}>
                              <ReleaseCard release={release} />
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </>
      ) : (
        <LoadingScreen />
      )}
    </>
  );
};

export default ReleaseDetails;
